import { ThemeOptions } from '@mui/material';

export const chipThemeOptions: ThemeOptions = {
  components: {
    MuiChip: {
      styleOverrides: {
        sizeSmall: {
          width: 'fit-content',
        },
        sizeMedium: {
          width: 'fit-content',
        },
      },
    },
  },
};
